<template>
  <a-form :model="form" labelAlign="right" :label-col="{ span: miniMode ? '5' : '4' }" :wrapper-col="{ span: miniMode ? '17' : '18' }">
    <a-form-item label="上传至分组" v-if="!miniMode">
      <a-select
        v-model:value="form.group_id"
        style="width: 130px"
        show-search
        optionFilterProp="label"
        placeholder="请选择分组"
        :disabled="hasAuthority(['29'])"
      >
        <a-select-option v-for="(item, key) in groupList" :value="item.group_id" :label="item.name" :key="key">{{ item.name }}</a-select-option>
      </a-select>
      <a-button type="link" style="margin-left: 10px" @click="addGroup" v-if="!hasAuthority(['29'])">新建</a-button>
    </a-form-item>
    <template v-if="qrName != ''">
      <a-form-item label="活码名称" class="qr-form-item">
        <label>{{ qrName }}</label>
      </a-form-item>
      <a-form-item class="qr-form-item">
        <template #label>
          活码通道
          <a-tooltip overlayClassName="tooltip-box" placement="top">
            <template #title>
              <div style="width: 300px">
                默认通道采用{考试名称}考试群，辅助通道采用{考试名称}考试群-，分别进行关键词匹配关联群，请上传活码前检查企业微信后台的配置
              </div>
            </template>
            <ehf-icon
              icon="question-line"
              style="margin-left: 3px; color: #666; font-size: 18px; cursor: pointer; vertical-align: -5px; margin-left: 5px"
            ></ehf-icon>
          </a-tooltip>
        </template>
        <a-radio-group v-model:value="form.channel_type">
          <a-radio :value="1">默认通道</a-radio>
          <a-radio :value="2">辅助通道</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="入群形式" class="qr-form-item">
        <a-radio-group v-model:value="form.qrType">
          <a-radio :value="2">点击链接</a-radio>
          <a-radio :value="1">二维码扫码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="form.qrType == 2" label="链接地址" class="qr-form-item">
        <a-input v-model:value="form.qrUrl" style="width: 500px" placeholder="请输入" />
      </a-form-item>
    </template>

    <a-form-item v-if="qrName == '' || form.qrType == 1" label="本地图片" class="upload">
      <div class="upload-wrapper">
        <div class="upload-item" v-if="(!multiple || edit) && form.url !== ''">
          <img :src="form.url" class="upload-item__img" />
          <div class="mock">
            <ehf-icon class="image-edit-btn" icon="delete-bin-6-line" @click.stop="removeImage()"></ehf-icon>
          </div>
        </div>
        <template v-if="multiple && !edit">
          <div class="upload-item" v-for="(url, i) in form.urlList" :key="i">
            <img :src="url" class="upload-item__img" />
            <div class="mock">
              <ehf-icon class="image-edit-btn" icon="delete-bin-6-line" @click.stop="removeImage(i)"></ehf-icon>
            </div>
          </div>
        </template>
        <div
          class="upload-item"
          style="cursor: pointer; border-style: dashed"
          v-show="((!multiple || edit) && form.url === '') || (multiple && !edit && fileList.length < max)"
          @click="picBtn()"
          @drop.prevent.stop="fileDrop"
          @dragover.prevent
        >
          <ehf-icon icon="add-fill" class="upload-add-icon"></ehf-icon>
          <input type="file" @change="imageChange" ref="imageInputRef" accept="image/*" :multiple="multiple" />
        </div>
      </div>
      <div class="tips">
        注意：
        <br />
        1.图片上传支持{{ acceptFormat.join('、') }}格式
        <span v-show="multiple">，至多选择{{ max }}张图片同时上传</span>
        ;
        <br />
        <span>2.图片上传最大支持{{ limit.text }}大小;</span>
      </div>
    </a-form-item>
  </a-form>
  <div class="footer" :class="{ 'from-iframe': pageType === 'iframe' }">
    <a-button @click="onCancel">取消</a-button>
    <a-button type="primary" @click="onSubmit" :loading="uploading">确定</a-button>
  </div>

  <!-- 新增分组 -->
  <a-modal v-model:open="groupModal.show" title="新增分组" :confirmLoading="groupModal.confirmLoading" centered @ok="confirmSaveGroup">
    <a-form :model="groupModal" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="分组名称">
        <a-input v-model:value="groupModal.name" placeholder="请输入分组名称" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
  export default {
    name: 'UploadImage',
    methods: {},
  }
</script>

<script setup>
  import { uploadImg, getMaterialGroupList, saveMaterialGroup } from '@/api/system/imageGroup'
  import { compressImage, hasAuthority } from '../../../utils'
  import { useGetters } from '@/utils/composables'
  import { useStore } from 'vuex'
  import { ref, reactive, computed, onBeforeUnmount } from 'vue'
  import { message } from 'ant-design-vue'

  const props = defineProps({
    multiple: {
      type: Boolean,
      default() {
        return false
      },
    },
    edit: {
      type: Boolean,
      default() {
        return false
      },
    },
    max: {
      type: Number,
      default: 10,
    },
    miniMode: {
      type: Boolean,
      default: false,
    },
    compressRate: {
      type: Number,
      default: 0,
    },
    forceCanvasCompress: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Object,
      default() {
        return {
          text: '2MB',
          size: 2 * 1024 * 1024,
        }
      },
    },
    groupId: {
      type: String,
      default: '0',
    },
    limitSize: {
      type: Object,
      default() {
        return {
          width: null,
          height: null,
        }
      },
    },
    maxWidth: {
      type: Number,
      default: null,
    },
    maxHeight: {
      type: Number,
      default: null,
    },
    pageType: {
      type: String,
      default: '',
    },
    acceptFormat: {
      type: Array,
      default() {
        return ['jpg', 'png', 'gif']
      },
    },
    // 针对企业微信二维码 需求[ID1006395]
    qrName: {
      type: String,
      default() {
        return ''
      },
    },
    // 是否需要缓存
    needCache: {
      type: Boolean,
      default: false,
    },
  })
  const emit = defineEmits(['cancel', 'upload'])
  const { imageUpload: imageUploadCache } = useGetters('components', ['imageUpload']) // 缓存的上传组件数据

  const uploading = ref(false) // 上传loading
  const groupModal = reactive({
    show: false,
    name: '',
    confirmLoading: false,
  }) // 新增分组弹窗
  const form = reactive({
    group_id: null,
    url: '',
    urlList: [],
    qrType: 2,
    qrUrl: '',
    channel_type: 1,
  })
  const groupList = ref([]) // 分组列表
  const fileList = ref([]) // 待上传图片列表
  const mimeMap = {
    jpg: ['image/jpg', 'image/jpeg', 'image/JPG', 'image/JPEG'],
    png: ['image/png', 'image/PNG'],
    gif: ['image/gif', 'image/GIF'],
  }
  const acceptList = computed(() => {
    let resList = []
    props.acceptFormat.forEach((item) => {
      if (mimeMap[item]) {
        resList = resList.concat(mimeMap[item])
      }
    })
    return resList
  })
  const store = useStore()
  const setImageUploadCache = (options) => store.dispatch('components/setImageUploadCache', options) // 设置组件部分数据缓存

  onBeforeUnmount(() => {
    if (props.needCache) {
      setImageUploadCache({ groupId: form.group_id })
    }
  })

  // 初始化
  const init = () => {
    let groupId = props.groupId === '' ? '0' : props.groupId
    if (props.needCache && imageUploadCache.value) {
      groupId = imageUploadCache.value.groupId || '0'
    }
    getGroupList(groupId)
  }
  // 获取分组列表
  const getGroupList = (id) => {
    getMaterialGroupList().then((res) => {
      if (res.code === 0) {
        const groups = res.data
        groupList.value = groups
        id && (form.group_id = id)
        //如果是供应商，默认选中供应商分组
        if (hasAuthority(['29'])) {
          form.group_id = res.data[0].group_id
        }
      }
    })
  }
  // 新增分组
  const addGroup = () => {
    groupModal.name = ''
    groupModal.show = true
  }
  // 确认保存分组信息
  const confirmSaveGroup = async () => {
    if (groupModal.name === '') {
      return message.error('请填写分组名称')
    }
    const body = {
      group_id: '',
      name: groupModal.name,
    }
    groupModal.confirmLoading = true
    const res = await saveMaterialGroup(body)
    groupModal.confirmLoading = false
    if (res && res.code === 0) {
      message.success('保存成功')
      groupModal.show = false
      getGroupList(res.data.id)
    } else {
      message.error(res ? res.msg : '操作失败')
    }
  }
  // 点击上传图片按钮
  const imageInputRef = ref(null)
  const picBtn = () => {
    imageInputRef.value.click()
  }
  // 图片变化时预览
  const imageChange = async (e) => {
    let file = null
    //设置上传最长长度
    let maxLength = 0
    //如果上传数量大于限制的数量 - 已上传数量 ，则截取至限制数量 - 已上传数量
    maxLength = e.target.files.length > props.max - form.urlList.length ? props.max - form.urlList.length : e.target.files.length
    if (props.multiple) {
      for (let i = 0; i < maxLength; i++) {
        file = e.target.files[i]
        file = await compressImage(file, props.compressRate, props.limit.size, props.forceCanvasCompress)
        imagePreview(file)
      }
    } else {
      file = e.target.files[0]
      file = await compressImage(file, props.compressRate, props.limit.size, props.forceCanvasCompress)
      imagePreview(file)
    }
  }
  // 图片预览显示
  const imagePreview = (file) => {
    const limit = props.limit.size
    if (acceptList.value.indexOf(file.type) === -1) {
      imageInputRef.value.value = ''
      return message.error(`只能选择 ${props.acceptFormat.join('、')} 格式！`)
    }
    if (file.size > limit) {
      imageInputRef.value.value = ''
      return message.error(`图片上传最大支持${props.limit.text}大小`)
    }
    const reader = new FileReader()
    reader.onload = function () {
      let img = new Image()
      img.src = reader.result.toString()
      img.onload = () => {
        let width = img.width
        let height = img.height
        if (props.limitSize.width && props.limitSize.height) {
          if (props.limitSize.width !== width || props.limitSize.height !== height) {
            return message.error(`所上传图片不符合尺寸，请上传 ${props.limitSize.width} * ${props.limitSize.height} 尺寸的图片。`)
          }
        }
        if (props.limitSize.width && !props.limitSize.height) {
          if (props.limitSize.width !== width) {
            return message.error(`所上传图片宽度不符合尺寸，请上传宽度为 ${props.limitSize.width} 的图片。`)
          }
        }
        if (props.limitSize.height && !props.limitSize.width) {
          if (props.limitSize.height !== height) {
            return message.error(`所上传图片高度不符合尺寸，请上传高度为 ${props.limitSize.height} 的图片。`)
          }
        }
        if (props.maxWidth && props.maxHeight) {
          if (width > props.maxWidth || height > props.maxHeight) {
            return message.error(`所上传图片超过最大尺寸，请上传宽和高不超过 ${props.maxWidth} * ${props.maxHeight} 的图片。`)
          }
        }
        if (props.maxWidth && !props.maxHeight) {
          if (width > props.maxWidth) {
            return message.error(`所上传图片宽度超过限制，请上传宽度不超过 ${props.maxWidth} 的图片。`)
          }
        }
        if (!props.maxWidth && props.maxHeight) {
          if (height > props.maxHeight) {
            return message.error(`所上传图片高度超过限制，请上传高度不超过 ${props.maxHeight} 的图片。`)
          }
        }
        if (props.multiple && !props.edit) {
          form.urlList.push(this.result)
        } else {
          form.url = this.result
        }
        imageInputRef.value.value = ''
        let fileType = ''
        for (let key in mimeMap) {
          if (mimeMap[key].indexOf(file.type) > -1) {
            fileType = key
          }
        }
        fileList.value.push({ file, ext_name: fileType })
      }
    }
    reader.readAsDataURL(file)
  }
  // 移除预览图片
  const removeImage = (index) => {
    if (index) {
      fileList.value.splice(index, 1)
      form.urlList.splice(index, 1)
    } else {
      fileList.value = []
      form.urlList = []
      form.url = ''
    }
  }
  // 点击确定
  const onSubmit = async () => {
    // 需求[ID1006395] 由于二维码上传借用上传图片组件 但是分组是固定的
    var tempGroupID = form.group_id
    if (props.qrName != '') {
      if (form.qrType == 2) {
        if (form.qrUrl !== '') {
          emit('upload', [form.qrUrl], { qrType: 2, channel_type: form.channel_type })
        } else {
          message.error('请输入链接')
        }
        return
      } else {
        tempGroupID = '42'
      }
    }
    let promiseList = []
    fileList.value.forEach((v) => {
      const body = {
        ...v,
        group_id: tempGroupID,
        upload: true,
      }
      promiseList.push(uploadImg(body))
    })
    uploading.value = true
    // 批量上传图片
    const resList = await Promise.all(promiseList)
    uploading.value = false
    let urlList = []
    resList.forEach((res) => {
      if (res && res.code === 0) {
        if (props.qrName == '') {
          message.success('上传成功')
        }
        urlList.push(res.data)
      } else {
        message.error(res ? res.msg : '上传失败')
      }
    })
    if (props.pageType === 'iframe') {
      window.parent.postMessage({ cmd: 'upload_success', url: urlList[0] }, '*')
    } else {
      emit('upload', urlList, { channel_type: form.channel_type })
    }
  }
  // 点击取消
  const onCancel = () => {
    if (props.pageType === 'iframe') {
      window.parent.postMessage({ cmd: 'close_upload_modal' }, '*')
    } else {
      emit('cancel')
    }
  }
  const fileDrop = async (e) => {
    let file = e.dataTransfer.files[0]
    file = await compressImage(file, props.compressRate, props.limit.size, props.forceCanvasCompress)
    imagePreview(file)
  }

  init()
</script>

<style lang="scss" scoped>
  ::v-deep(.ant-form-item) {
    line-height: 40px;
  }
  .qr-form-item {
    ::v-deep(.ant-form-item-control) {
      display: flex;
      flex-flow: row nowrap;
    }
  }
  .upload-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-height: 360px;
    overflow-y: auto;
    .upload-item {
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      border: 1px none #cccccc;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .upload-item__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .upload-add-icon {
        font-size: 30px;
      }
      .mock {
        display: none;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);
        .image-edit-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          cursor: pointer;
          font-size: 24px;
        }
      }
      &:hover {
        .mock {
          display: block;
        }
      }
      input {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        opacity: 0;
        display: none;
      }
    }
  }
  .tips {
    color: #999;
    font-size: 13px;
    line-height: initial;
  }
  .footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    padding-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
</style>
